'use strict';
var win = require( '@rei/browser-shim' ).win;
var $ = require( 'jquery' );

var doc = win.document;
var originalPathName = location.pathname;
var pathName = originalPathName;

var getQueryString = function ( ) {
    return location.search.substring( 1 );
};

var getPathName = function ( ) {
    return location.pathname;
};

// Returns the Current Query String as an Object
var getQueryParamAsObj = function ( queryString ) {
    var queryParameters = {};
    var regEx           = /([^&=]+)=([^&]*)/g;
    var parsedParams;
    while ( parsedParams = regEx.exec( queryString ) ) {
        var paramKey    = parsedParams[ 1 ];
        var paramValue  = parsedParams[ 2 ];
        if ( queryParameters[ paramKey ] ) {
            // Handle If Query Param Is Listed Multiple Times
            if ( Array.isArray( queryParameters[ paramKey ] ) ) {
                // Param value is array, push into it
                queryParameters[ paramKey ].push( paramValue );
            } else {
                // Convert Param Value to Array and Push Values Into It.
                var existingParamValue = queryParameters[ paramKey ];
                queryParameters[ paramKey ] = [];
                queryParameters[ paramKey ].push( existingParamValue );
                queryParameters[ paramKey ].push( paramValue );
            }
        } else {
            queryParameters[ paramKey ] = paramValue;
        }
    }
    return queryParameters;
};

var addQueryParam = function ( queryString, paramName, paramValue ) {
    var queryParameters = getQueryParamAsObj( queryString );
    if ( queryParameters[ paramName ] ) {
        // Handle If Query Param Is Listed Multiple Times
        if ( Array.isArray( queryParameters[ paramName ] ) ) {
            // Param value is array, push into it unless it already exists
            var existsAlready = queryParameters[ paramName ].indexOf( paramValue ) > -1;
            if ( !existsAlready ) {
                queryParameters[ paramName ].push( paramValue );
            }
        } else {
            // Convert Param Value to Array and Push Values Into It.
            var existingParamValue = queryParameters[ paramName ];
            queryParameters[ paramName ] = [];
            queryParameters[ paramName ].push( existingParamValue );
            queryParameters[ paramName ].push( paramValue );
        }
    } else {
        queryParameters[ paramName ] =  paramValue;
    }
    return decodeURIComponent( $.param( queryParameters, true ) );
};

var changeQueryParam = function ( queryString, changedParam, paramValue ) {
    var queryParameters = getQueryParamAsObj( queryString );
    if ( changedParam && paramValue ) queryParameters[ changedParam ] = paramValue;
    return decodeURIComponent( $.param( queryParameters, true ) );
};

var replaceQueryParam = function ( queryString, originalParam, newParam, paramValue ) {
    var queryParameters = getQueryParamAsObj( queryString );
    if ( originalParam ) delete queryParameters[ originalParam ];
    if ( newParam && paramValue ) queryParameters[ newParam ] = paramValue;
    return decodeURIComponent( $.param( queryParameters, true ) );
};

var removeMatches = function ( obj, key, val ) {
    var modifiedObj = obj;
    // If multiple params per key, find in array and remove
    if ( Array.isArray( modifiedObj[ key ] ) ){
        // check for a direct match
        var index = modifiedObj[ key ].indexOf( val );
        // check for an encoded match
        if ( index === -1 ) {
            index = modifiedObj[ key ].indexOf( encodeURIComponent( val ) );
        }
        // check for an decoded match
        if ( index === -1 ) {
            index = modifiedObj[ key ].indexOf( decodeURIComponent( val ) );
        }
        // if we have a match, let's remove it
        if ( index > -1 ) {
            modifiedObj[ key ].splice( index, 1 );
        }
    } else {
        // check for direct, encoded and decoded matches on the object
        if ( modifiedObj[ key ] === val
          || modifiedObj[ key ] === encodeURIComponent ( val )
          || modifiedObj[ key ] === decodeURIComponent ( val ) ) {
            delete modifiedObj[ key ];
        }
    }
    return modifiedObj;
}

var removeMatchedQueryParam = function ( queryString, paramName, paramValue ) {
    var queryParameters = getQueryParamAsObj( queryString );
    queryParameters = removeMatches(queryParameters, paramName, paramValue);
    return decodeURIComponent( $.param( queryParameters, true ) );
};

var removeQueryParams = function ( queryString, paramNames ) {
    // Return if Empty Query String, nothing to remove
    if ( queryString == '' ) return queryString;
    var queryParameters = getQueryParamAsObj( queryString );
    var arrayOfParams    = [];

    // If arg is not array, push into array
    if ( Array.isArray( paramNames ) ) {
        arrayOfParams = paramNames;
    } else {
        arrayOfParams.push( paramNames );
    }
    arrayOfParams.forEach( function ( paramToRemove ) {
        // If : found, then split and remove value
        var paramToRemove      = paramToRemove.split( ':' );
        paramToRemove          = paramToRemove.map( function ( i ) {
            return i.trim();
        });
        // If a key/value is found by splitting on :
        if ( paramToRemove.length > 1 ) {
            var paramName   = paramToRemove[ 0 ];
            var paramValue  = paramToRemove[ 1 ];
            queryParameters = removeMatches(queryParameters, paramName, paramValue);
        } else {
            // If not providing a value, delete param by key all together.
            delete queryParameters[ paramToRemove ];
        }
    } );
    return decodeURIComponent( $.param( queryParameters, true ) );
};

var pushStatePageChange = function ( queryString, pathString, newPageName ) {

    var newURI = "";
    var pageName = newPageName ? newPageName : doc.title;

    // If root path set, set to absolute, else use relative
    if ( pathString ) {
        pathName = pathString;
    }

    newURI = pathName;

    if ( queryString ) {
        newURI += '?' + queryString
    }

    // Clean up URI
    newURI = newURI.replace('//', '/');

    // See if pushState is supported, else reload the page
    if ( win.history.pushState ) {
        var stateObj = {};
        win.history.pushState( stateObj, pageName, newURI );
    } else {
        win.location = newURI;
    }
};

var getPathName = function () {
    return pathName;
};

var setPathName = function ( newPathName ) {
    pathName = newPathName;
};

var restorePathName = function () {
    pathName = originalPathName;
};
var getOriginalPathName = function () {
    return originalPathName;
};

module.exports = {
    getQueryString:             getQueryString,
    getPathName:                getPathName,
    getOriginalPathName:        getOriginalPathName,
    setPathName:                setPathName,
    restorePathName:            restorePathName,
    getQueryParamAsObj:         getQueryParamAsObj,
    addQueryParam:              addQueryParam,
    changeQueryParam:           changeQueryParam,
    replaceQueryParam:          replaceQueryParam,
    removeQueryParams:          removeQueryParams,
    removeMatchedQueryParam:    removeMatchedQueryParam,
    pushStatePageChange:        pushStatePageChange
}
